import { yup } from '@framework/validation';
import { FieldValues, Path, useController } from 'react-hook-form';
import { useFormItemContext } from '../item/FormItemContext';
import { useResetDefaultOnDisableEffect } from './useResetDefaultOnDisableEffect';

/**
 * Utility centralizzata per gestire il controller (RHF)
 * di tutti i componenti di input
 */
export function useInputController<
  T = any,
  TFieldValues extends FieldValues = Record<string, T>,
>(
  name: Path<TFieldValues>,
  options: { enabled: boolean | undefined; schema?: yup.MixedSchema },
) {
  const { enabled } = options;
  const { schema: formItemSchemas, name: formItemName } = useFormItemContext();

  // Attualmente, è necessario che il _primo_ nome del formItem sia uguale al
  // nome del controller.
  //
  // Potremmo anche utilizzare `useFieldAugmentedSchema`,
  // che permette di ottenere a priori del FormItem lo schema di validazione,
  // tuttavia andrebbe affinato per gestire meglio sia la memoizzazione.
  //
  // In alternativa, potremmo controllare tutti gli N schemi di validazione,
  // e ad esempio nel caso di MultiSelect, passare entrambi i `name` al FormItem.
  //    <FormItem name={['multiSelect', 'multiSelect_options@internal']} />
  const isFormItemSchemaCompatible = formItemName?.[0] === name;
  // if (!isFormItemSchemaCompatible) {
  //   console.info(`[useInputController] Il nome del formItem non corrisponde al nome del controller.`, { formItemName, name }); // prettier-ignore
  // }

  const inputSchema = options.schema ?? formItemSchemas?.[0];
  const controller = useController<TFieldValues>({
    name: name,
    defaultValue: inputSchema?.getDefault(),
  });

  // Imposta il valore di default quando il campo viene disabilitato
  useResetDefaultOnDisableEffect(controller.field, enabled, inputSchema);

  return controller;
}
